export default "__VITE_ASSET__CBbw_xsm__"